import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import Bread from "../../common/Bread";
import { useForm } from "react-hook-form";
import { GoLocation } from "react-icons/go";
import { BsTelephone } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
import "./contact.scss";
import ContactMap from "../../components/ContactMap";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";

const ContactUs = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const [formLoading, setFormLoading] = useState(false);
  const captchaRef = useRef(null);

  const breadcrumList = {
    image: "",
    title: "Contact Us",
    l1: "Home",
    l2: "Contact Us",
    l3: "",
  };

  const onSubmit = async (values) => {
    setFormLoading(true);

    // Get reCAPTCHA token
    const token = captchaRef.current.getValue();

    if (!token) {
      toast.error("You must confirm you are not a robot");
      setFormLoading(false);
      return;
    }

    try {
      const { data } = await axios.post(
        "https://admin.icfcbank.com/api/contacts/add_feedback",
        {
          ...values,
          token,
          secret: process.env.REACT_APP_SECRET_KEY,
        }
      );

      if (data.status === "SUCCESS") {
        toast.success("Your message was successfully sent.");
        reset();
      } else {
        toast.error(data.status_message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Submission failed. Please try again.");
    } finally {
      setFormLoading(false);
      captchaRef.current.reset(); // Reset captcha every time
    }
  };

  return (
    <Bread data={breadcrumList}>
      <div className="contactPageMainContainer">
        <div className="top-flex-container">
          <div className="flex-item">
            <div className="iconContainer">
              <GoLocation className="icon" />
            </div>
            <div className="contentContainer">
              <h3>Address</h3>
              <p>
                ICFC Finance Limited - Head Office, Thirbam Sadhak-2,
                Bhatbhateni
              </p>
            </div>
          </div>

          <div className="flex-item">
            <div className="iconContainer">
              <BsTelephone className="icon" />
            </div>
            <div className="contentContainer">
              <h3>Phone</h3>
              <p>01-4525292</p>
            </div>
          </div>

          <div className="flex-item">
            <div className="iconContainer">
              <MdOutlineEmail className="icon" />
            </div>
            <div className="contentContainer">
              <h3>Email</h3>
              <p>info@icfcbank.com</p>
            </div>
          </div>
        </div>

        <div className="bottom-flex-container">
          <div className="formContainer">
            <h2>Contact Us</h2>
            <form className="form" onSubmit={handleSubmit(onSubmit)}>
              <div className="contactFormInputContainer">
                <label>Full Name</label>
                <input
                  type="text"
                  {...register("fullname", {
                    required: "Full Name is Required",
                  })}
                  placeholder="Full Name"
                />
                <span>{errors.fullname?.message}</span>
              </div>

              <div className="contactFormInputContainer">
                <label>Email</label>
                <input
                  type="text"
                  {...register("email", {
                    required: "Email is Required",
                    pattern: {
                      value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  placeholder="Email"
                />
                <span>{errors.email?.message}</span>
              </div>

              <div className="contactFormInputContainer">
                <label>Mobile Number</label>
                <input
                  type="text"
                  {...register("phone", {
                    required: "Phone is Required",
                    pattern: {
                      value: /^[\+]?[0-9\s\-().]{7,20}$/,
                      message: "Invalid phone number",
                    },
                  })}
                  placeholder="Mobile Number"
                />
                <span>{errors.phone?.message}</span>
              </div>

              <div className="contactFormInputContainer">
                <label>Address</label>
                <input
                  type="text"
                  {...register("address", { required: "Address is Required" })}
                  placeholder="Address"
                />
                <span>{errors.address?.message}</span>
              </div>

              <div className="contactFormInputContainer">
                <label>Your Message</label>
                <textarea
                  rows="5"
                  {...register("message", {
                    required: "Message is Required",
                    minLength: { value: 5, message: "Minimum 5 characters" },
                    maxLength: { value: 5000, message: "Max 5000 characters" },
                  })}
                  placeholder="Message"
                />
                <span>{errors.message?.message}</span>
              </div>

              <div className="captchaContainer">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  ref={captchaRef}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting || formLoading}
                className="contactFormResetButton contactSubmitButton"
              >
                {formLoading && <ClipLoader size={20} color="#fff" />}
                Submit
              </button>
            </form>
          </div>

          <div className="mapContainer">
            <ContactMap />
          </div>
        </div>
      </div>
    </Bread>
  );
};

export default ContactUs;
